import { render } from "./TheReleaseStationGenerals.vue?vue&type=template&id=e680119e"
import script from "./TheReleaseStationGenerals.vue?vue&type=script&lang=js"
export * from "./TheReleaseStationGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__